/**
 * @module SiteLegal
 * @description
 */
import { FC } from "react";
import styles from "./index.module.css";
import setHtml from "ui/js/utils/setHtml";

interface Props {
  lines?: string[]
}

const SiteLegal: FC<Props> = (props) => {
  const legal: string[] = props?.lines || [
    // 1
    `
      Based on comparison of 2 Gig Service plan upload speed of up to 2000 Mbps
      versus advertised cable upload speeds for Xfinity Gigabit plan of 35 Mbps,
      Spectrum Internet Gig plan of 35 Mbps, and Optimum 1 Gig Internet plan of
      35 Mbps.
    `,

    // 2
    `
      For new business Internet customers only. Max speeds are wired and
      location dependent. Max speed capable range for 500 Mbps (450-500 Mbps
      download/upload). Max speed capable range for 1 Gig (846-1000 Mbps
      download and 792-1000 Mbps upload). Max speed capable range for Fiber 2
      Gig (1800-2000 Mbps download/upload) and requires 2 Gbps capable devices
      and wiring. Performance details available at <a
        href="https://frontier.com/internetdisclosures"
        target="_blank"
        rel="noopener noreferrer"
      >frontier.com/internetdisclosures</a>.
      Requires Auto Pay or $5/mo. fee applies. A $10 discount is applied to
      the first 12 months of service. Printed bill available for $3.49/mo. Fee
      does not apply to select customers. Up to a $95 installation fee may apply
      unless specified in the offer. A $50 equipment restocking fee per account
      applies when internet is disconnected. A fee up to $150 per device also
      applies if equipment is not returned. Other applicable charges and
      additional services are extra. Subject to availability. Price and terms
      subject to change. Cannot be combined with other offers. Other
      restrictions, Frontier policies and service terms apply.
    `,
  ];

  return (
    <div id="site-legal" className={styles.siteLegal}>
      <ol className={styles.ol}>
        {legal.map((l: string, index: number) => (
          <li key={index} id={`legal-${index}`} {...setHtml(l)} />
        ))}
      </ol>
    </div>
  );
};

SiteLegal.displayName = "SiteLegal";

export default SiteLegal;
